import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS_COLLECTION_CARDS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';

const CollectionPage = () => {
  const { sport, generateSportContextPath } = useSportContext();
  const { slug, collection } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS_COLLECTION_CARDS,
        {
          sport,
          params: {
            slug,
            collection,
          },
        }
      )}
      replace
    />
  );
};
export default CollectionPage;
